export const GET_TENANT_REQUEST = 'GET_TENANT_REQUEST'
export const GET_TENANT_SUCCESS = 'GET_TENANT_SUCCESS'
export const GET_TENANT_ERROR = 'GET_TENANT_ERROR'